
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { DriverClient, CompanyClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import { convertCurrency } from '@/utils'

@Component({
  name: 'CompanyRechargeEditor',
  components: {}
})
export default class extends BaseEditor {
  @Prop({ default: -1 })
  private companyId !: number
  private driverList = []
  private company = { account_balance: 0 }
  private driverClient = new DriverClient()
  public constructor() {
    super()
    this.client = new CompanyClient()
    this.data = {
      drivers: [],
      recharge_amount: 0
    }
    this.rules = {
      drivers: [{ required: true, message: '司机为必选项', trigger: 'blur' }],
      recharge_amount: [
        { required: true, message: '充值金额不能为空', trigger: 'blur' },
        { validator: this.checkRechargeAmount, trigger: 'blur' },
        {
          type: 'number',
          min: 0.01,
          max: 9999999,
          message: '充值金额必须在正常范围[0.01~9999999]',
          trigger: 'blur'
        }
      ]
    }
  }

  get rechargeTotalAmount(): string {
    return convertCurrency(this.data.drivers.length * this.data.recharge_amount)
  }
  get companyAmount(): string {
    return convertCurrency(this.company.account_balance)
  }

  get smallToBIG(): string {
    return convertCurrency(this.data.recharge_amount)
  }

  private checkRechargeAmount(rule:any, value:any, callback:any) {
    if (!parseFloat(this.data.recharge_amount)) {
      return callback(new Error('充值金额无效'))
    } else if (this.data.drivers.length * this.data.recharge_amount >
          this.company.account_balance) {
      return callback(new Error('企业余额不足'))
    } else {
      return callback()
    }
  }

  async created() {
    super.created()
    await this.getCompany(this.companyId)
    await this.getDriverList(this.companyId)
  }

  async mounted() {
    const driverTransfer = document.getElementById('driverTransfer')
    const totalWidth = driverTransfer!.clientWidth
    let remainWidth = totalWidth
    const elements = document.getElementsByClassName('el-transfer__buttons')
    if (elements.length > 0) {
      remainWidth = totalWidth - elements[0].clientWidth
    }

    const panels:any = document.getElementsByClassName('el-transfer-panel')
    for (const panel of panels) {
      panel.style.width = `${remainWidth / 2 - 1}px`
    }
  }

  private async getDriverList(companyId:number) {
    this.driverList = await this.driverClient.fetch({
      filter: {
        where: { isDeleted: false, companyId },
        fields: {
          id: true,
          name: true,
          mobile_phone_number: true
        },
        order: ['name']
      }
    })
  }

  private async getCompany(companyId:number) {
    this.company = await this.client.get(companyId)
  }

  public async reset() {
    this.data = {
      drivers: [],
      recharge_amount: 0
    }
  }

  protected generateData(): any {
    const data = _.pick(this.data, [
      'drivers',
      'recharge_amount'
    ])
    data.recharge_amount = Number(data.recharge_amount)
    return this.clearData(data)
  }

  public async recharge():Promise<Boolean> {
    const self = this
    const form = self.$refs['dataForm'] as any
    const companyClient = this.client as CompanyClient
    return new Promise<Boolean>((resolve, reject) => {
      form.validate(async(valid: any) => {
        if (valid) {
          self.listLoading = true
          await companyClient.rechargeDriver(self.companyId, self.data)
          self.listLoading = false
          self.$notify({
            title: '成功',
            message: '充值成功',
            type: 'success',
            duration: 2000
          })
          resolve(true)
        } else {
          resolve(false)
        }
      })
    })
  }
}
